import { render } from "./CadParceiros.vue?vue&type=template&id=4605f440"
import script from "./CadParceiros.vue?vue&type=script&lang=js"
export * from "./CadParceiros.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__